var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-wrapper"},[_c('v-pagination',{attrs:{"page-count":_vm.totalPages,"classes":_vm.bootstrapPaginationClasses,"labels":_vm.paginationAnchorTexts},model:{value:(_vm.changePage),callback:function ($$v) {_vm.changePage=$$v},expression:"changePage"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4d5db7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/Pager.vue
// module id = null
// module chunks = 